<template>
  <v-navigation-drawer v-model="localDrawer" temporary right app width="400">
    <v-card class="pt-4 elevation-0">
      <div class="d-flex justify-end hidden-md-and-up">
        <v-btn class="ma-1" x-small outlined fixed fab right @click.stop.prevent="localDrawer = false">
          <v-icon small> fas fa-times </v-icon>
        </v-btn>
      </div>
    </v-card>
    <v-toolbar flat>
      <v-list-item two-line class="pa-0 font-weight-bold subheading mb-4">
        <v-list-item-content>
          <v-list-item-title>TUTORIALES</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-toolbar>
    <div v-for="(frequentQuestion, i) in getFrequentQuestions" :key="i" class="px-4 mb-10">
      <h4>
        <span>{{ i + 1 }}. </span>
        {{ frequentQuestion.question }}
      </h4>
      <p class="font-weight-regular ma-3 grey--text text--darken-1">
        {{ frequentQuestion.detail }}
      </p>
      <p class="my-2 ml-3">
        {{ frequentQuestion.answer }}
      </p>
      <div class="ml-3">
        <v-btn
          v-if="frequentQuestion.tutorial"
          dense
          small
          color="accent"
          class="black--text"
          @click="setTutorial({ tutorial: frequentQuestion.tutorial })"
        >
          Ver tutorial
        </v-btn>
      </div>
      <v-divider class="mt-10" />
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "FrequentQuestionsDrawer",
  computed: {
    ...mapGetters(["showFrequentQuestionsDrawer", "getFrequentQuestions"]),
    localDrawer: {
      get() {
        return this.showFrequentQuestionsDrawer;
      },
      set(v) {
        if (!v) this.setShowFrequentQuestionsDrawer(false);
      },
    },
  },
  methods: {
    ...mapActions(["setShowFrequentQuestionsDrawer", "setTutorial"]),
  },
};
</script>
